<template>
  <div :style="style">
    <div class="absolute-cover pointer-events-none" :style="strokeStyle" />
  </div>
</template>

<script setup>

  const props = defineProps({
    element: Object
  });

  const content = computed(() => props.element.content);
  const surfaceEditorUtils = useSurfaceEditorUtils();

  const style = computed(() => ({
    ...surfaceEditorUtils.fillToStyle({fill: content.value.fill, patternOffset: content.value.stroke_width}),
    borderRadius: `${content.value.rounding}%`
  }));

  const strokeStyle = computed(() => ({
    borderColor: content.value.stroke_color,
    borderWidth: `${content.value.stroke_width}px`,
    borderStyle: content.value.stroke_type,
    borderRadius: `${content.value.rounding}%`
  }));


</script>
